module.exports = __webpack_public_path__ + "static/goliath-1-75088a18da0f8855631858e73600f831.png";